import { Autocomplete, CircularProgress, TextField, FormControlLabel, Checkbox, Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { RelatoriosContext } from "../RelatoriosContext";
import { buscarComboPorCodigo } from "../../../services/auth.service";
import MensagemErro from "../../../components/MensagemErro";

const TabRelatorios = () => {
  const { dadosRelatorios, setDadosRelatorios } = useContext(RelatoriosContext);
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [msg, setMsg] = useState("");
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  useEffect(() => {

    setItemSelecionado(dadosRelatorios.tipoRelatorio);
    const fetchTipoRelatorio = async () => {
      try {
        setLoading(true);
        const response = await buscarComboPorCodigo("TIPORELATORIO");
        const tipos = response.detalhes.itensCombo.map((item) => {
          const split = item.split("/|/");
          return { id: split[0], nome: split[1] };
        });
        setOptions(tipos);
      } catch (error) {
        setMsg(error.response.data.mensagem);
        setOpenSnackbarErro(true);
      } finally {
        setLoading(false);
      }
    };

    fetchTipoRelatorio();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "codigoRelatorio":
        setDadosRelatorios({
          ...dadosRelatorios,
          [name]: value.toString().toUpperCase().replace(" ", "_"),
        });
        break;
      default:
        setDadosRelatorios({ ...dadosRelatorios, [name]: value.toString() });
        break;
    }
  };

  const handleChangeAutocomplete = (name, value) => {

    setItemSelecionado(value);
    setDadosRelatorios({
      ...dadosRelatorios,
      [name]: parseInt(value.id),
    });
  };

  return (
    <div>
      <TextField
        label="Nome do Relatório"
        fullWidth
        onChange={handleChange}
        name="nome"
        value={dadosRelatorios.nome}
      />
      <br />
      <br />
      <TextField
        label="Código do Relatório"
        fullWidth
        onChange={handleChange}
        name="codigoRelatorio"
        value={dadosRelatorios.codigoRelatorio}
      />
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            options={options}
            fullWidth
            size="small"
            value={itemSelecionado}
            loading={loading}
            onChange={(_, value) =>
              handleChangeAutocomplete("idTipoRelatorio", value)
            }
            getOptionLabel={(option) => option.nome}
            isOptionEqualToValue={(option, value) => option.nome === value.nome}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tipo"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={dadosRelatorios.apuracao || false}
                onChange={(e) =>
                  setDadosRelatorios({
                    ...dadosRelatorios,
                    apuracao: e.target.checked,
                  })
                }
              />
            }
            label="Data por Apuração"
            sx={{ 
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: { xs: "8px", sm: "0px" }
            }}
          />
        </Grid>
      </Grid>
      <br />
      <br />
      <TextField
        label="Script"
        multiline
        fullWidth
        rows={8}
        name="script"
        onChange={handleChange}
        value={dadosRelatorios.script}
      />
      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default TabRelatorios;
